import { ImagePreview } from 'vant'

function handler(event) {
  const instance = ImagePreview({
    images: [event.target.src],
    closeable: true,
    onClose() {
      instance.close()
    }
  })
  event.preventDefault()
  event.stopPropagation()
}

function previewHandler(evt) {
  if (evt.target.tagName.toLowerCase() !== 'img') {
    return
  }
  handler(evt)
}

export function previewImage(el) {
  el.removeEventListener('click', previewHandler)
  el.addEventListener('click', previewHandler, true)
  // let imgList = el.getElementsByTagName('img')
  // for (let i = 0; i < imgList.length; i++) {
  //   const img = imgList[i]
  //   img.onclick = handler
  // }
}
